"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _icons = require("@ant-design/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const openModals = [];
class UnsavedChangesModal extends _react.default.Component {
  state = {
    isModalVisible: false
  };
  componentDidMount() {
    this.restorePathname = location.pathname;
    openModals.push(this);
  }
  componentWillUnmount() {
    const index = openModals.indexOf(this);
    if (index >= 0) {
      openModals.splice(index, 1);
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.showModal && this.props.showModal) {
      this.setState({
        isModalVisible: true
      });
    }
  }
  render() {
    const {
      saving,
      className
    } = this.props;
    const {
      isModalVisible
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_antd.Modal, {
      title: /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_icons.InfoCircleOutlined, {
        style: {
          color: '#1890ff'
        }
      }), /*#__PURE__*/_react.default.createElement("span", null, "Save Changes")),
      className: className,
      open: isModalVisible,
      onCancel: this.handleCloseClick,
      closable: true,
      cancelButtonProps: {
        ghost: true,
        danger: true
      },
      footer: [/*#__PURE__*/_react.default.createElement(_antd.Button, {
        key: "discard",
        ghost: true,
        danger: true,
        onClick: this.handleCancelClick
      }, "Discard"), /*#__PURE__*/_react.default.createElement(_antd.Button, {
        key: "submit",
        type: "primary",
        loading: saving,
        onClick: this.handleOkClick
      }, "Save")]
    }, /*#__PURE__*/_react.default.createElement("p", null, "You have unsaved changes. Click the Save button to ensure your changes are saved. If you wish to discard your changes, click Discard."));
  }
  handleOkClick = async () => {
    const {
      onSave
    } = this.props;
    const {
      successCallback,
      failCallback
    } = this.state;
    try {
      if (typeof onSave === 'function') {
        await onSave();
      }
      this.setState({
        isModalVisible: false
      }, successCallback);
    } catch (error) {
      console.error('Error saving changes', error);
      this.setState({
        isModalVisible: false
      }, failCallback);
    }
  };
  handleCancelClick = async () => {
    const {
      onDiscard
    } = this.props;
    const {
      successCallback,
      failCallback
    } = this.state;
    try {
      if (typeof onDiscard === 'function') {
        await onDiscard();
      }
      this.setState({
        isModalVisible: false
      }, successCallback);
    } catch (error) {
      console.error('Error discarding changes:', error);
      this.setState({
        isModalVisible: false
      }, failCallback);
    }
  };
  handleCloseClick = () => {
    const {
      failCallback
    } = this.state;
    this.setState({
      isModalVisible: false
    }, failCallback);
  };
  shouldShow = () => {
    return !this.props.disabled;
  };
  show = (successCallback, failCallback) => {
    this.setState({
      isModalVisible: true,
      successCallback,
      failCallback
    });
  };
}
exports.default = UnsavedChangesModal;
UnsavedChangesModal.getOpenModals = () => {
  return [...openModals];
};
UnsavedChangesModal.routerMiddleware = function unsavedChangesMiddleware(action, nextRoute, prevRoute) {
  if (openModals.length === 0) {
    action.ok();
    return;
  }
  const modal = openModals[openModals.length - 1];
  if (!modal) {
    action.ok();
    return;
  }
  if (!modal.shouldShow()) {
    action.ok();
    return;
  }
  modal.show(action.ok, action.cancel);
};
//# sourceMappingURL=unsaved-changes-modal.js.map